











































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { ToggleButton } from 'vue-js-toggle-button';

import driverPayout from '@/table/setting/driverPayout';

import getHubs from '@/gql/company/getHubs.gql';
import getDriverPayouts from '@/gql/driverPayout/getDriverPayouts.gql';
import deleteDriverPayout from '@/gql/driverPayout/deleteDriverPayout.gql';
import updateDriverPayout from '@/gql/driverPayout/updateDriverPayout.gql';

import CommonFormWithDriverPayoutEditor from '@/components/Setting/CommonFormWithDriverPayoutEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import useAuth from '@/useAuth';

const DriverPayout = defineComponent({
  components: {
    ToggleButton,
    CommonModalWithPreset,
    CommonFormWithDriverPayoutEditor,
  },
  setup() {
    const { me } = useAuth();
    const search: Ref<string> = ref('');
    const searchCode: Ref<string> = ref('');
    const searchArea: Ref<string> = ref('');
    const searchHub: Ref<any> = ref(null);
    const getDriverPayoutsResult = (data: any) => data.driverPayouts;
    // ==== Use to search User ==== //
    const getDriverPayoutsVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterName: undefined,
        filterCode: undefined,
        filterArea: undefined,
        filterHub: undefined,
      };
      if (me.hub.hubType !== 'MAIN' || searchHub.value) {
        vars.filterHub = {
          column: 'ID',
          value: searchHub.value?.id || me.hubId,
        };
      }
      if (search.value) {
        vars.filterName = `%${search.value}%`;
      }
      if (searchCode.value) {
        vars.filterCode = `%${searchCode.value}%`;
      }
      // if (searchArea.value) {
      //   vars.filterArea = `%${searchArea.value}%`;
      // }
      return vars;
    });

    const addDriverPayoutModal = ref(null);
    const editDriverPayoutId = ref(-1);

    // =============================================
    // ===== Use to delete Account from system =====
    // =============================================
    const deleteDriverPayoutModal = ref(null);
    const deleteDeliveryMutation = useMutation(deleteDriverPayout, {
      refetchQueries: ['getDriverPayouts'],
    });
    function deleteDriverPayoutAction(deliveryId: number) {
      deleteDeliveryMutation.mutate({
        id: deliveryId,
      });
    }

    // Active Deactive Mutation
    const toggleVariables = reactive({
      id: '',
      status: true,
    });
    const updateDriverPayoutMutation = useMutation(
      updateDriverPayout,
      () => ({
        variables: {
          input: {
            id: toggleVariables.id,
            active: toggleVariables.status,
          },
        },
        refetchQueries: ['getDriverPayouts'],
      }),
    );
    function setActiveStatus(id: any, status: boolean) {
      toggleVariables.id = id;
      toggleVariables.status = status;
      updateDriverPayoutMutation.mutate();
    }

    return {
      me,
      search,
      searchCode,
      searchArea,

      getHubs,
      searchHub,

      driverPayoutsTableOptions: driverPayout,
      getDriverPayoutsQuery: getDriverPayouts,
      getDriverPayoutsVariables,
      getDriverPayoutsResult,

      addDriverPayoutModal,
      editDriverPayoutId,

      deleteDriverPayoutModal,
      deleteDriverPayoutAction,

      setActiveStatus,
    };
  },
});

export default DriverPayout;
